import {
  ConfluenceDatabaseAriResourceOwner,
  ConfluenceDatabaseAriResourceType
} from "./chunk-PGMODI5S.mjs";
import {
  RegisteredAri
} from "./chunk-YG2E6ZVD.mjs";
import {
  AriParser
} from "./chunk-Q7FABYST.mjs";

// src/confluence/database/manifest.ts
var confluenceDatabaseAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: ConfluenceDatabaseAriResourceOwner,
  resourceType: ConfluenceDatabaseAriResourceType,
  resourceIdSlug: "activation/{activationId}/{databaseId}",
  resourceIdSegmentFormats: {
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    databaseId: /[0-9]+/
    // eslint-disable-line no-useless-escape
  }
};

// src/confluence/database/index.ts
var ConfluenceDatabaseAri = class _ConfluenceDatabaseAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
  }
  get siteId() {
    return this._siteId;
  }
  get activationId() {
    return this._activationId;
  }
  get databaseId() {
    return this._databaseId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: confluenceDatabaseAriStaticOpts.qualifier,
      platformQualifier: confluenceDatabaseAriStaticOpts.platformQualifier,
      cloudId: opts.siteId,
      resourceOwner: confluenceDatabaseAriStaticOpts.resourceOwner,
      resourceType: confluenceDatabaseAriStaticOpts.resourceType,
      resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
      resourceIdSegmentValues: {
        activationId: opts.activationId,
        databaseId: opts.databaseId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, confluenceDatabaseAriStaticOpts);
    return new _ConfluenceDatabaseAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, confluenceDatabaseAriStaticOpts);
    return new _ConfluenceDatabaseAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId,
      activationId: this.activationId,
      databaseId: this.databaseId
    };
  }
};

export {
  ConfluenceDatabaseAri
};
